import React from "react";
import { Skeleton, Grid } from "@mui/material";

const SkeletonChatMessages = ({ }) => {
  return (
    <>
      <Grid container wrap="nowrap" direction="column" gap="16px" height="100%">
        <Grid item container wrap="nowrap" direction="row" gap="12px">
          <Skeleton variant="circular" width={40} height={40} style={{backgroundColor: "#E2E4E6", alignSelf:"flex-end", marginBottom:"18px"}}/>
          <Skeleton variant="rounded" width="calc(100% - 40px - 36px - 12px)" height={160} style={{backgroundColor: "#F3F4F5"}}/>
        </Grid>
        <Grid item container wrap="nowrap" direction="row-reverse">
          <Skeleton variant="rounded" width="calc(100% - 88px)" height={80} style={{backgroundColor: "#F3F4F5"}}/>
        </Grid>
        <Grid item container wrap="nowrap" direction="row" gap="12px">
          <Skeleton variant="circular" width={40} height={40} style={{backgroundColor: "#E2E4E6", alignSelf:"flex-end", marginBottom:"18px"}}/>
          <Skeleton variant="rounded" width="calc(100% - 40px - 36px - 12px)" height={160} style={{backgroundColor: "#F3F4F5"}}/>
        </Grid>
      </Grid>
    </>
  );
};

export default SkeletonChatMessages;
